// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"12057979","513":"ac98af45","703":"a18eb93e"}[chunkId] + ".chunk.js";
};